<template>
    <div class="product-prices px-3">

        <div class="row">
            <div class="col-md-5 col-lg-6">{{ config.translate.stock_status }}:</div>
            <div class="col-md-7 col-lg-6 product-stock-status text-right">
                <div class="product-prices-underlined">
                    <span v-html="productDetails.stock_status"></span>
                </div>
            </div>
        </div>
        <div class="row" v-if="parseFloat(productDetails.calc.totalPrice) == 0 && parseFloat(productDetails.stock_quantity) == 0">

            <div class="col-md-12 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ config.translate.ask_our_colleagues}}</strong>
                </div>
            </div>
        </div>
      <div class="row" v-if="parseFloat(productDetails.calc.unitPrice) > 0">
            <div class="col-md-5 col-lg-6">
                <strong :class="{ strikethrough: !!productDetails.calc.discountPrice }">{{ config.translate.unit_price }}:</strong>
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong :class="{ strikethrough: !!productDetails.calc.discountPrice }">{{ formatNumber(productDetails.calc.unitPrice) }} {{ productDetails.currency }} / <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span> + {{ config.translate.vat }}</strong>
                </div>
            </div>
        </div>
        <div class="row" v-if="productDetails.calc.discountPrice">
            <div class="col-md-5 col-lg-6">
                <strong>{{ config.translate.discount_price }}:</strong>
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ formatNumber(productDetails.calc.discountPrice) }} {{ productDetails.currency }} / <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span> + {{ config.translate.vat }}</strong>
                </div>
            </div>
        </div>
      <div class="row" v-if="parseFloat(productDetails.calc.unitGrossPrice) > 0">
            <div class="col-md-5 col-lg-6" style="white-space: nowrap;">
              {{ config.translate.unit_price }} ({{ config.translate.gross }}):
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ formatNumber(productDetails.calc.unitGrossPrice) }} {{ productDetails.currency }} / <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span></strong>
                </div>
            </div>
        </div>
        <div class="row" v-if="productDetails.display_needed_quantity !== productDetails.display_payable_quantity">
            <div class="col-md-5 col-lg-6">
                {{ config.translate.quantity_requested }}: 
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ productDetails.display_needed_quantity }} <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span></strong>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 col-lg-6" style="white-space: nowrap;">
              {{ config.translate.quantity_payable }}:
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ productDetails.display_payable_quantity }} <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span></strong>
                </div>
            </div>
        </div>
        <div class="row" v-if="parseFloat(tablePrice) > 0">
            <div class="col-md-5 col-lg-6">
                <strong>{{ productDetails.unit != 'm2' ? config.translate.piece_price : (multipleTables ? config.translate.tables_price : config.translate.table_price) }}: </strong>
                <a class="my-toop-tip" :title="productDetails.cut_rule" data-toggle="tooltip" data-placement="left">
                    <i class="fa fa-question-circle"/>
                </a>
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ formatNumber(tablePrice) }} {{ productDetails.currency }} + {{ config.translate.vat }}</strong>
                </div>
            </div>
        </div>
        
        <div class="row" v-if="parseFloat(productDetails.calc.totalGrossPrice) > 0">
            <div class="col-md-5 col-lg-6" style="white-space: nowrap;">
                {{ config.translate.altogether }} ({{ config.translate.gross }}):
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="product-prices-underlined">
                    <strong>{{ formatNumber(productDetails.calc.totalGrossPrice) }} {{ productDetails.currency }} </strong>
                </div>
            </div>
        </div>

        <div class="row last-price" v-if="parseFloat(productDetails.calc.totalPrice) > 0">
            <div class="col-md-5 col-lg-6">
                <strong>{{ config.translate.altogether }}:</strong>
            </div>
            <div class="col-md-7 col-lg-6 product-price text-right red-text">
                <div class="price-total">
                    <strong>{{ formatNumber(productDetails.calc.totalPrice) }} {{ productDetails.currency }} + {{ config.translate.vat }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Details',
  props: ['config', 'productDetails', 'multipleTables', 'tablePrice'],
  methods: {
    formatNumber(number){
      return new Number(number).toLocaleString(this.productDetails.ccy_code, {minimumFractionDigits: this.productDetails.ccy_precision});
    }
  }
}
</script>
